import { render } from "./PollCard.vue?vue&type=template&id=579789f1&scoped=true"
import script from "./PollCard.vue?vue&type=script&lang=js"
export * from "./PollCard.vue?vue&type=script&lang=js"

import "./PollCard.vue?vue&type=style&index=0&id=579789f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579789f1"]])

export default __exports__